import BaseAPIS from '../download-base'

// 数据中心
class DataCentersService extends BaseAPIS {
  // 数据中心-数据导出list
  fetchDataExport(params) {
    return this.get({
      url: '/bulletin-front/bulletin-export/list',
      params,
    })
  }
  // 数据中心-数据导出list by cem权限
  fetchDataExportCem(params) {
    return this.get({
      url: '/data-source/export/list-by-user',
      params,
    })
  }
  // 数据中心-数据导出点击
  fetchDataClick(body) {
    return this.get({
      url: '/bulletin-front/authorized/download',
      data: body,
    })
  }
  // 数据中心-删除记录
  fetchDataDelete(body) {
    return this.post({
      url: '/bulletin-front/bulletin-export/delete',
      data: body,
    })
  }
  // 获取下载文件临时授权
  getAuthorizedDownload(params) {
    return this.get({
      url: `/bulletin-front/bulletin-export/authorized/download`,
      params,
    })
  }

  // 数据中心-导出重试
  fetchDataRetry(body) {
    return this.post({
      url: '/bulletin-front/bulletin-export/retry',
      data: body,
    })
  }
}

export default new DataCentersService()
